import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", name: "", password: "", workspace_name: "HOP! Founder" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.email, form.name, form.password, form.workspace_name);
      toast.success("Workspace created");
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "#F9F8F6", fontFamily: "'Satoshi', system-ui, sans-serif" }}>
      <div className="w-full max-w-md bg-white border border-neutral-200 rounded-lg p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-10 h-10 rounded-md flex items-center justify-center" style={{ background: "#D4FF00" }}>
            <Sparkles className="w-6 h-6" color="#1A1A1A" strokeWidth={2} />
          </div>
          <div>
            <div className="font-black text-2xl tracking-tight leading-none" style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>HOP!</div>
            <div className="text-[10px] uppercase tracking-widest text-neutral-500">Founder Content OS</div>
          </div>
        </div>
        <h1 className="text-3xl font-black tracking-tight mb-1" style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>Create workspace</h1>
        <p className="text-sm text-neutral-600 mb-6">Every workspace is pre-seeded with HOP! brand, products, voice rules and competitor watchlist.</p>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="reg-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            placeholder="Your name" className="w-full border border-neutral-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-neutral-900" />
          <input data-testid="reg-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            placeholder="you@hop.com" className="w-full border border-neutral-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-neutral-900" />
          <input data-testid="reg-password" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
            placeholder="Password (min 6 chars)" className="w-full border border-neutral-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-neutral-900" />
          <input data-testid="reg-workspace" required value={form.workspace_name} onChange={(e) => setForm({ ...form, workspace_name: e.target.value })}
            placeholder="Workspace name" className="w-full border border-neutral-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-neutral-900" />
          <button data-testid="register-submit" type="submit" disabled={loading}
            className="w-full py-2.5 rounded-md font-semibold text-sm text-neutral-900 disabled:opacity-50" style={{ background: "#D4FF00" }}>
            {loading ? "Creating..." : "Create workspace"}
          </button>
        </form>
        <div className="text-sm text-neutral-600 mt-6">
          Already have an account? <Link to="/login" data-testid="go-login" className="font-semibold text-neutral-900 underline">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
